import { useState, useEffect } from 'react';
import { useQuery, useSubscription } from '@apollo/client';
import { GET_NOTIFICATIONS } from '@/graphql/queries/getNotifications';
import { ON_NEW_NOTIFICATION } from '@/graphql/subscriptions/onNewNotification';

export const useUnreadNotificationsCount = () => {
  const [unreadCount, setUnreadCount] = useState(0);

  const { data: queryData, refetch } = useQuery(GET_NOTIFICATIONS, {
    fetchPolicy: 'cache-and-network',
    pollInterval: 30000,
    errorPolicy: 'all',
    onCompleted: (data) => {
      if (data?.userNotifications) {
        const unread = data.userNotifications.filter((n: { read: boolean }) => !n.read).length;
        setUnreadCount(unread);
      }
    },
  });

  const { data: subscriptionData } = useSubscription(ON_NEW_NOTIFICATION);

  useEffect(() => {
    if (subscriptionData?.newNotification) {
      const newNotification = subscriptionData.newNotification;
      if (!newNotification.read) {
        setUnreadCount((prev) => prev + 1);
        refetch();
      }
    }
  }, [subscriptionData, refetch]);

  useEffect(() => {
    if (queryData?.userNotifications) {
      const unread = queryData.userNotifications.filter((n: { read: boolean }) => !n.read).length;
      setUnreadCount(unread);
    }
  }, [queryData]);

  return { unreadCount, refetch };
};

